'use client';

import { useState, useEffect } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

const StickyHeaderNavigation = () => {
  const { language } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isRTL = language === 'ar';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = {
    ar: [
      { label: 'الرئيسية', href: '#home' },
      { label: 'من نحن', href: '#about' },
      { label: 'الخدمات', href: '#services' },
      { label: 'القضايا', href: '#cases' },
      { label: 'الأخبار', href: '#news' },
      { label: 'تواصل معنا', href: '#contact' },
    ],
    en: [
      { label: 'Home', href: '#home' },
      { label: 'About Us', href: '#about' },
      { label: 'Services', href: '#services' },
      { label: 'Public Cases', href: '#cases' },
      { label: 'News', href: '#news' },
      { label: 'Contact Us', href: '#contact' },
    ],
  };

  const items = menuItems[language];

  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      const headerOffset = 120;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <nav data-component-id="src/components/common/StickyHeaderNavigation.tsx:59:6" data-component-path="src/components/common/StickyHeaderNavigation.tsx" data-component-line="59" data-component-end-line="130" data-component-file="StickyHeaderNavigation.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%7D"
        className={`bg-white border-b border-accent/20 transition-all duration-300 ${
          isScrolled ? 'shadow-md' : ''
        }`}
        dir={isRTL ? 'rtl' : 'ltr'}
      >
        <div data-component-id="src/components/common/StickyHeaderNavigation.tsx:65:8" data-component-path="src/components/common/StickyHeaderNavigation.tsx" data-component-line="65" data-component-end-line="110" data-component-file="StickyHeaderNavigation.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%20lg%3Apx-10%22%7D" className="container mx-auto px-4 lg:px-10">
          <div data-component-id="src/components/common/StickyHeaderNavigation.tsx:66:10" data-component-path="src/components/common/StickyHeaderNavigation.tsx" data-component-line="66" data-component-end-line="109" data-component-file="StickyHeaderNavigation.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20h-14%22%7D" className="flex items-center justify-between h-14">
            {/* Desktop Menu - Centered */}
            <div data-component-id="src/components/common/StickyHeaderNavigation.tsx:68:12" data-component-path="src/components/common/StickyHeaderNavigation.tsx" data-component-line="68" data-component-end-line="79" data-component-file="StickyHeaderNavigation.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20lg%3Aflex%20items-center%20justify-center%20flex-1%20gap-1%22%7D" className="hidden lg:flex items-center justify-center flex-1 gap-1">
              {items.map((item, index) => (
                <button data-component-id="src/components/common/StickyHeaderNavigation.tsx:70:16" data-component-path="src/components/common/StickyHeaderNavigation.tsx" data-component-line="70" data-component-end-line="77" data-component-file="StickyHeaderNavigation.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22relative%20px-3%20py-2%20font-inter%20font-medium%20text-sm%20text-primary-foreground%20hover%3Atext-accent%20transition-colors%20duration-200%20group%22%7D"
                  key={index}
                  onClick={() => scrollToSection(item.href)}
                  className="relative px-3 py-2 font-inter font-medium text-sm text-primary-foreground hover:text-accent transition-colors duration-200 group"
                >
                  {item.label}
                  <span data-component-id="src/components/common/StickyHeaderNavigation.tsx:76:18" data-component-path="src/components/common/StickyHeaderNavigation.tsx" data-component-line="76" data-component-end-line="76" data-component-file="StickyHeaderNavigation.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22absolute%20bottom-0%20left-0%20w-0%20h-0.5%20bg-accent%20transition-all%20duration-300%20group-hover%3Aw-full%22%7D" className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-300 group-hover:w-full" />
                </button>
              ))}
            </div>

            {/* Mobile Menu Button */}
            <button data-component-id="src/components/common/StickyHeaderNavigation.tsx:82:12" data-component-path="src/components/common/StickyHeaderNavigation.tsx" data-component-line="82" data-component-end-line="108" data-component-file="StickyHeaderNavigation.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22lg%3Ahidden%20p-2%20text-primary-foreground%20hover%3Atext-accent%20transition-colors%20duration-200%20ml-auto%22%7D"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2 text-primary-foreground hover:text-accent transition-colors duration-200 ml-auto"
            >
              <svg data-component-id="src/components/common/StickyHeaderNavigation.tsx:86:14" data-component-path="src/components/common/StickyHeaderNavigation.tsx" data-component-line="86" data-component-end-line="107" data-component-file="StickyHeaderNavigation.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22w-6%20h-6%22%7D"
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                {isMobileMenuOpen ? (
                  <path data-component-id="src/components/common/StickyHeaderNavigation.tsx:93:18" data-component-path="src/components/common/StickyHeaderNavigation.tsx" data-component-line="93" data-component-end-line="98" data-component-file="StickyHeaderNavigation.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path data-component-id="src/components/common/StickyHeaderNavigation.tsx:100:18" data-component-path="src/components/common/StickyHeaderNavigation.tsx" data-component-line="100" data-component-end-line="105" data-component-file="StickyHeaderNavigation.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        {isMobileMenuOpen && (
          <div data-component-id="src/components/common/StickyHeaderNavigation.tsx:114:10" data-component-path="src/components/common/StickyHeaderNavigation.tsx" data-component-line="114" data-component-end-line="128" data-component-file="StickyHeaderNavigation.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Ahidden%20bg-primary%20border-t%20border-accent%2F30%22%7D" className="lg:hidden bg-primary border-t border-accent/30">
            <div data-component-id="src/components/common/StickyHeaderNavigation.tsx:115:12" data-component-path="src/components/common/StickyHeaderNavigation.tsx" data-component-line="115" data-component-end-line="127" data-component-file="StickyHeaderNavigation.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%20py-4%22%7D" className="container mx-auto px-4 py-4">
              <div data-component-id="src/components/common/StickyHeaderNavigation.tsx:116:14" data-component-path="src/components/common/StickyHeaderNavigation.tsx" data-component-line="116" data-component-end-line="126" data-component-file="StickyHeaderNavigation.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-2%22%7D" className="flex flex-col gap-2">
                {items.map((item, index) => (
                  <button data-component-id="src/components/common/StickyHeaderNavigation.tsx:118:18" data-component-path="src/components/common/StickyHeaderNavigation.tsx" data-component-line="118" data-component-end-line="124" data-component-file="StickyHeaderNavigation.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22px-4%20py-3%20font-inter%20font-medium%20text-base%20text-primary-foreground%20hover%3Atext-accent%20hover%3Abg-primary%2F50%20rounded-lg%20text-left%20transition-colors%20duration-200%22%7D"
                    key={index}
                    onClick={() => scrollToSection(item.href)}
                    className="px-4 py-3 font-inter font-medium text-base text-primary-foreground hover:text-accent hover:bg-primary/50 rounded-lg text-left transition-colors duration-200"
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default StickyHeaderNavigation;